import { messages as ptMessages } from './pt';
import { messages as esMessages } from './es';

export const resources = {
  ...ptMessages,
  ...esMessages,
};
